/**
 * mahitab-review-videos.js                                       [CRO edits]
 *
 * Customer review video grid for fabric product pages, below اراء العملاء.
 *
 * Loads assets/CustomerReviewVideos.json (70 clips hosted on Shopify Files,
 * uploaded by ~/mahitab_fabric_work/upload_review_videos.py) and renders a
 * poster grid. Nothing but the poster JPEGs is fetched up front - the video is
 * only requested when a card is opened. That matters: the clips run 15s to 5.8
 * minutes, and these pages already weigh 5-6 MB before anything is added.
 *
 * Order is shuffled on every page load so the same clips are not always the
 * ones seen, and so a fabric page does not look identical to the last one.
 *
 * PLAYBACK OPENS IN A LIGHTBOX, not inside the card. Playing inline meant the
 * card had to grow from its 4:5 poster box to the clip's 9:16, which pushed
 * the rest of the grid row down - it looked broken. The lightbox leaves the
 * grid completely still, shows the clip at its true proportions, and lets a
 * shopper move through testimonials with the arrows instead of returning to
 * the grid between each one.
 */
(function () {
  'use strict';

  var lb = null, lbItems = [], lbIndex = 0, lastFocus = null;

  function shuffle(a) {
    // Fisher-Yates. Order is genuinely random per page load rather than a
    // rotation, so every clip gets exposure over time.
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ------------------------------------------------------------- lightbox */

  function buildLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'mhb-rv-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="mhb-rv-lb__close" aria-label="إغلاق">&times;</button>' +
      '<button type="button" class="mhb-rv-lb__nav mhb-rv-lb__nav--prev" aria-label="السابق">&#8249;</button>' +
      '<div class="mhb-rv-lb__stage"></div>' +
      '<button type="button" class="mhb-rv-lb__nav mhb-rv-lb__nav--next" aria-label="التالي">&#8250;</button>';

    // Backdrop only - a click on the video or the controls must not close it.
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    lb.querySelector('.mhb-rv-lb__close').addEventListener('click', closeLb);
    lb.querySelector('.mhb-rv-lb__nav--prev').addEventListener('click', function () { step(-1); });
    lb.querySelector('.mhb-rv-lb__nav--next').addEventListener('click', function () { step(1); });

    document.addEventListener('keydown', function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') step(1);
      else if (e.key === 'ArrowLeft') step(-1);
    });

    document.body.appendChild(lb);
    return lb;
  }

  function show(i) {
    var it = lbItems[i];
    if (!it) return;
    lbIndex = i;

    var stage = lb.querySelector('.mhb-rv-lb__stage');
    stage.innerHTML = '';

    var v = document.createElement('video');
    v.src = it.video_url;
    v.controls = true;
    v.playsInline = true;
    v.autoplay = true;
    v.preload = 'metadata';
    if (it.poster_url) v.poster = it.poster_url;
    stage.appendChild(v);

    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay blocked: controls are there */ });

    var multi = lbItems.length > 1;
    lb.querySelector('.mhb-rv-lb__nav--prev').hidden = !multi;
    lb.querySelector('.mhb-rv-lb__nav--next').hidden = !multi;
  }

  function step(dir) {
    if (!lbItems.length) return;
    show((lbIndex + dir + lbItems.length) % lbItems.length);
  }

  function openLb(items, i) {
    buildLightbox();
    lbItems = items;
    lastFocus = document.activeElement;

    // Stop anything already playing elsewhere on the page, including the
    // فيديوهات لاراء عملاءنا carousel higher up.
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (!lb.contains(v)) v.pause();
    });

    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';  // no scrolling behind
    show(i);
    lb.querySelector('.mhb-rv-lb__close').focus();
  }

  function closeLb() {
    if (!lb || lb.hidden) return;
    var v = lb.querySelector('video');
    // Drop the source so the clip stops downloading the moment it is closed.
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    lb.querySelector('.mhb-rv-lb__stage').innerHTML = '';
    lb.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ----------------------------------------------------------------- grid */

  function card(it, all, index) {
    var fig = document.createElement('button');
    fig.type = 'button';
    fig.className = 'mhb-rv__card';
    fig.setAttribute('aria-label', 'شغّل الفيديو');

    var img = document.createElement('img');
    img.className = 'mhb-rv__poster';
    img.src = it.poster_url;
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    fig.appendChild(img);

    var play = document.createElement('span');
    play.className = 'mhb-rv__play';
    play.setAttribute('aria-hidden', 'true');
    fig.appendChild(play);

    fig.addEventListener('click', function () { openLb(all, index); });
    return fig;
  }

  function init() {
    var root = document.querySelector('[data-mhb-rv]');
    if (!root) return;

    var grid = root.querySelector('[data-mhb-rv-grid]');
    var moreBtn = root.querySelector('[data-mhb-rv-more]');
    var step_ = parseInt(root.getAttribute('data-step'), 10) || 8;
    var src = root.getAttribute('data-json');
    if (!grid || !src) return;

    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var items = (data.items || []).filter(function (it) {
          return it && it.video_url && it.poster_url;
        });
        if (!items.length) return;

        shuffle(items);
        var shown = 0;

        function renderNext() {
          var slice = items.slice(shown, shown + step_);
          slice.forEach(function (it, k) { grid.appendChild(card(it, items, shown + k)); });
          shown += slice.length;
          if (moreBtn) moreBtn.hidden = shown >= items.length;
        }

        if (moreBtn) moreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          renderNext();
        });

        renderNext();
        root.hidden = false;
      })
      .catch(function () { /* leave hidden; the page is unaffected */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
